<template>
    <div>
        <b-card class="m-0" no-body>
            <b-card-header class="d-flex justify-content-between align-items-center">
                <h5 class="modal-title">{{ isKonfirmasi ? 'Konfirmasi' : (isPenarikan ? 'Penarikan' : 'Pengisian') }} Dana Gudang</h5>
            </b-card-header>
            <b-card-body v-show="isKonfirmasi">
                <p>{{ isPenarikan ? 'Penarikan' : 'Pengisian' }} sebesar Rp. {{ formatNumber(form.nominal) }}.</p>
                <p>Total saldo akan berubah menjadi berikut</p>
                <template v-if="gudang">
                    <p>Rekening Gudang : Rp. {{ formatNumberStrict(parseInt(gudang.saldo_rekening_gudang) + parseInt(nominal)) }}</p>
                    <p v-if="isPenarikan">Kas Kecil : Rp. {{ formatNumberStrict(parseInt(gudang.saldo_kas_kecil) + parseInt(form.nominal)) }}</p>
                </template>
            </b-card-body>
            <b-card-body v-show="!isKonfirmasi">
                <div class="form-group" v-if="!gudang">
                    <label class="form-control-label">Gudang</label>
                    <div class="input-group mb-0 d-flex">
                        <multiselect :class="'w-auto flex-grow-1'" v-validate="'required'" name="gudang" v-model="gudang" :options="gudangOptions" :placeholder="'Pilih gudang'" :searchable="true"
                            label="name" track-by="id" :allowEmpty="false" :show-labels="false"></multiselect>
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="selectGudang = true"><i class="fas fa-search"></i> Pilih</button>
                        </div>
                    </div>
                    <span class="text-danger">{{ errors.first('gudang') }}</span>
                </div>

                <div class="form-group">
                    <label>Nominal</label>
                    <input v-validate="'required|min:0'" min="0" v-model="form.nominal" type="number" name="nominal" class="form-control">
                    <span class="text-danger">{{ errors.first('nominal') }}</span>
                </div>

                <div class="form-group">
                    <label>Keterangan</label>
                    <input v-model="form.notes" type="text" name="notes" class="form-control">
                    <span class="text-danger">{{ errors.first('notes') }}</span>
                </div>
            </b-card-body>
            <b-card-footer class="d-flex flex-row-reverse">
                <template v-if="isKonfirmasi">
                    <button :disabled="isLoading" @click="koreksi" type="button" class="btn btn-secondary">Koreksi</button>
                    <button :disabled="isLoading" @click="save" type="button" class="btn btn-primary mr-2">OK</button>
                </template>
                <template v-else>
                    <button :disabled="isLoading" @click="$emit('cancel')" type="button" class="btn btn-secondary" data-dismiss="modal">Batal</button>
                    <button :disabled="isLoading" @click="konfirmasi" type="button" class="btn btn-primary mr-2">Simpan</button>
                </template>
            </b-card-footer>
        </b-card>

        <b-modal v-model="selectGudang" size="lg" :hide-header="true" :hide-footer="true">
            <gudang-selector :selected="gudangOptions" @selected="gudangSelected" @cancel="selectGudang = false"></gudang-selector>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import GudangSelector from '../gudangs/Selector';

export default {
    name: "pengisian-dana-gudang-form",

    props: {
        isPenarikan: {
            type: Boolean,
            default: false,
        },

        gudang: {
            type: Object,
            default: () => {},
        },

        value: {
            type: Object,
            default: () => {},
        },
    },

    components: {
        Multiselect,
        GudangSelector,
    },

    data() {
        return {
            form: {
                nominal: null,
                metode: null,
            },
            selectGudang: false,
            gudangOptions: [],
            isKonfirmasi: false,
            metodeOptions: [
                {
                    name: 'tunai',
                    value: 'Tunai',
                },
                {
                    name: 'transfer',
                    value: 'Transfer',
                },
            ],
        }
    },

    created() {
        this.resetForm();
    },

    mounted() {
        this.resetForm();
    },

    computed: {
        nominal() {
            if (this.isPenarikan) {
                return parseInt(this.form.nominal) * -1;
            }
            return this.form.nominal;
        },
    },

    watch: {
    },

    methods: {
        resetForm() {
            this.form = Object.assign({}, {
                nominal: null,
                notes: null,
            });

            if (this.value) {
                this.form.nominal = this.value.nominal;
                this.form.notes = this.value.notes;
                if (this.isPenarikan) {
                    this.form.nominal = this.form.nominal * -1;
                }
            }
        },

        konfirmasi() {
            let self = this;

            if (self.value) {
                self.save();
                return;
            }

            self.$validator.validateAll().then(result => {
                if (result) {
                    self.isKonfirmasi = true;
                }
            });
        },

        koreksi() {
            this.isKonfirmasi = false;
        },

        save() {
            let self = this;

            self.isLoading = true;
            let data = {
                gudang_id: self.gudang ? self.gudang.id : null,
                nominal: self.form.nominal,
                notes: self.form.notes,
                is_penarikan: self.isPenarikan,
            }

            let api = self.value ? '/api/rekening-gudangs/'+self.value.id : '/api/rekening-gudangs';

            self.$Progress.start();
            axios({
                method: self.value ? 'put' : 'post',
                url: api,
                data: data
            })
            .then(function (response) {
                Toast.fire({
                    icon: 'success',
                    title: response.data.message
                });
                self.isLoading = false;
                self.$Progress.finish();
                self.$emit('saved', response.data.data);
            })
            .catch(function (error) {
                self.requestFailed(error);
            });
        },

        gudangSelected(gudang) {
            let self = this;

            self.gudangOptions.push(gudang);
            self.form.gudang = Object.assign({}, gudang);
            self.selectGudang = false;
        },
    },
}
</script>
